import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TDevice {
  id: number;
  deviceId: string;
  appId: string;
  description: string;
  registrationDate: Date;
}

export interface IDevice extends TDevice {}

const Device = Model(
  (model: TDevice): IDevice => {
    const _device: TDevice = Object.assign({}, model);

    const create = (device: IDevice): IDevice => {
      const obj = ValidatableObject(device);
      return obj;
    };

    const device = {
      get id() {
        return _device.id;
      },
      set id(value) {
        _device.id = value;
      },
      get deviceId() {
        return _device.deviceId;
      },
      set deviceId(value) {
        _device.deviceId = value;
      },
      get appId() {
        return _device.appId;
      },
      set appId(value) {
        _device.appId = value;
      },
      get description() {
        return _device.description;
      },
      set description(value) {
        _device.description = value;
      },
      get registrationDate() {
        return _device.registrationDate;
      },
      set registrationDate(value) {
        _device.registrationDate = value;
      }
    };

    return create(device);
  }
);

export default Device;
